import { render, staticRenderFns } from "./MoreBtn.vue?vue&type=template&id=76c1de76"
import script from "./MoreBtn.vue?vue&type=script&lang=js"
export * from "./MoreBtn.vue?vue&type=script&lang=js"
import style0 from "./MoreBtn.vue?vue&type=style&index=0&id=76c1de76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports